import { Button } from "@mui/material";
import SpeedIcon from "@mui/icons-material/Speed";

export default function PerformanceScreenButton() {
  return (
    <Button variant="text">
      <a href="performance-overview">
        <h3 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <SpeedIcon />
          overview
        </h3>
      </a>
    </Button>
  );
}
